
'use strict'

import Validate from './Validate';

class Email extends Validate {
    
    constructor(){
        super();
        this.error = '{name} no válido';
    }

    validate (value) {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value);
    }
}

export default Email;
